import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Default toast configuration
const defaultOptions = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'light',
};

// Generate a unique ID for each toast to prevent duplicates
const generateToastId = (message) => {
  return `toast-${message.substring(0, 20)}-${Date.now()}`;
};

const toastService = {
  // Success toast
  success: (message, options = {}) => {
    const toastId = generateToastId(`success-${message}`);
    toast.success(message, {
      ...defaultOptions,
      ...options,
      toastId,
    });
  },

  // Error toast with longer display time
  error: (message, options = {}) => {
    const toastId = generateToastId(`error-${message}`);
    toast.error(message, {
      ...defaultOptions,
      autoClose: 5000, // Longer display for errors
      ...options,
      toastId,
    });
  },

  // Warning toast
  warning: (message, options = {}) => {
    const toastId = generateToastId(`warning-${message}`);
    toast.warn(message, {
      ...defaultOptions,
      ...options,
      toastId,
    });
  },

  // Info toast
  info: (message, options = {}) => {
    const toastId = generateToastId(`info-${message}`);
    toast.info(message, {
      ...defaultOptions,
      ...options,
      toastId,
    });
  },

  // Dismiss all toasts
  dismiss: () => {
    toast.dismiss();
  },

  // Promise toast
  promise: (promise, messages, options = {}) => {
    const { pending, success, error } = messages;
    const toastId = generateToastId(`promise-${pending}`);
    return toast.promise(
      promise,
      {
        pending: {
          render: pending,
          icon: false,
        },
        success: {
          render: success,
          icon: '✅',
        },
        error: {
          render: error || 'An error occurred',
          icon: '❌',
        },
      },
      {
        ...defaultOptions,
        ...options,
        toastId,
      },
    );
  },
};

export default toastService;
